import { render, staticRenderFns } from "./HmFilterMicroShopGoods.vue?vue&type=template&id=e6837e4c&scoped=true&"
import script from "./HmFilterMicroShopGoods.vue?vue&type=script&lang=js&"
export * from "./HmFilterMicroShopGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6837e4c",
  null
  
)

component.options.__file = "HmFilterMicroShopGoods.vue"
export default component.exports